import { Component } from 'react'
import StandardContent from 'components/Popout/StandardContent'
import * as h from 'h'
export default class NotFoundView extends Component {
  render () {
    const { element } = this.props
    const { title, content } = element
    return h.div(null,
      h.h(StandardContent, {
        title: title,
        content: content
      }))
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/NotFoundView/index.js